import { BorderRadius, Color, getDefaultTransition } from '@billy/design-system'
import styled from '@emotion/styled'

export const Wrapper = styled.div`
  display: flex;
  align-items: stretch;
  width: 100%;
  height: 40px;
  border: 1px solid ${Color.Grey200};
  border-radius: ${BorderRadius.RFull};
  ${getDefaultTransition('border-color')};

  &:hover,
  &:focus-within {
    border-color: ${Color.Grey400};
  }
`

export const FiltersButtonWrapper = styled.div`
  display: flex;
  align-self: stretch;
  flex-direction: column;

  > button {
    flex: 1;
  }
`
